// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image_wrapper__l1Lmd","loader":"image_loader__O2_Mu","uploader":"image_uploader__MK75F","image":"image_image__8pLCt"};